import api from 'src/services/api';

export function contratarAssinatura({
  number,
  verification_value,
  first_name,
  last_name,
  month,
  year,
  identificador_iugu,
  email,
  payable_with = 'credit card',
  id_payment = null,
  cupom,
}) {
  return api.post('/criarAssinatura', {
    number,
    verification_value,
    first_name,
    last_name,
    month,
    year,
    plan_identifier: identificador_iugu,
    email,
    payable_with,
    id_payment,
    cupom,
  });
}

export function contratarServicoComCartaoCredito({
  id,
  number,
  first_name,
  last_name,
  month,
  year,
  verification_value,
  email,
  parcela,
  item,
  cpf_cnpj,
  address,
  username,
  servicoId,
  cupom,
  id_payment,
}) {
  return api.post('/realizarCobrancaDireta', {
    number,
    verification_value,
    first_name,
    last_name,
    month,
    year,
    method: 'credit_card',
    email: email,
    months: parcela,
    items: [item],
    cpf_cnpj: cpf_cnpj,
    street: address ? address.logradouro : '',
    address_number: address ? address.numero : '',
    name: username,
    zip_code: address ? address.cep : '',
    complement: address ? address.complemento : '',
    id_usuario: id,
    id_servico: servicoId,
    cupom,
    id_payment,
  });
}

const PagamentoService = {
  contratarAssinatura,
  contratarServicoComCartaoCredito,
};

export default PagamentoService;
